import { render, staticRenderFns } from "./FrenteImpressaoNascimento.vue?vue&type=template&id=4793e878&scoped=true&"
import script from "./FrenteImpressaoNascimento.vue?vue&type=script&lang=js&"
export * from "./FrenteImpressaoNascimento.vue?vue&type=script&lang=js&"
import style0 from "./FrenteImpressaoNascimento.vue?vue&type=style&index=0&id=4793e878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4793e878",
  null
  
)

export default component.exports